import { ConfigProvider, message } from "antd";
import ContiLayout from "./common/layout/ContiLayout";

message.config({
  duration: 3,
  maxCount: 3,
});

export default function RootLayout({ children }) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#03A6A6",
          fontSize: 16,
          fontFamily: "Montserrat",
        },
        components: {
          Button: {
            primary: {
              backgroundColor: "#03A6A6",
            },
            secondary: {
              backgroundColor: "#025373",
            },
            tertiary: {
              backgroundColor: "#f0f0f0",
            },
          },
          Menu: {
            itemActiveBg: "#1e1e1e",
            itemSelectedBg: "#04C6BD",
            itemSelectedColor: "#ffffff",
            subMenuItemSelectedColor: "#04C6BD",
          },
          Tabs: {
            cardBg: "#E7ECEC",
          },
        },
      }}
    >
      <ContiLayout children={children} />
    </ConfigProvider>
  );
}
